import { useIntl } from 'react-intl';

const useI18nText = (name: string) => {
  const intl = useIntl();
  return intl.formatMessage({ id: name });
};

export default useI18nText;
